import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './EmptyCart.module.sass';
import { taxonsSelector } from '../../selectors/taxons';

function EmptyCart(props) {
  const { taxons = [] } = props;

  return (
    <div className={styles['cart-empty']}>
      <div className={styles.title}>
        Your shopping bag is empty
      </div>
      <a href="/shop/">
        <div className={styles['shop-now']}>
          <div className={styles.image} />
          <div className={styles.title}>Shop now</div>
        </div>
      </a>
      <div className={styles.taxons}>
        { taxons.map((taxon) => (
          <a key={taxon.id} className={styles.taxon} href={taxon.url}>{taxon.name}</a>
        )) }
      </div>
    </div>
  );
}

EmptyCart.propTypes = {
  taxons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

const mapStateToProps = (state) => ({
  taxons: taxonsSelector(state),
});

export default connect(mapStateToProps)(EmptyCart);
